module.exports = __webpack_public_path__ + "static/girl-square-cbf6e180952fbc6b3f1f79062261001c.png";